// base
import { useState, forwardRef } from 'react';

// components
import { BasicTextFieldV2, type BasicTextFieldV2Props } from 'components';

interface BasicNumberInputProps extends Omit<BasicTextFieldV2Props, 'onChange'> {
  onChange: (value: string) => void;
}

export const BasicNumberInput = forwardRef<HTMLInputElement, BasicNumberInputProps>(
  ({ onChange, ...props }, ref) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleChange = (value: string) => {
      setInputValue(value);
      onChange(value);
    };

    return (
      <BasicTextFieldV2
        fullWidth
        type="number"
        maxLength={11}
        placeholder="101234567"
        value={inputValue}
        onChange={(e) => handleChange(e.target.value)}
        ref={ref}
        {...props}
      />
    );
  }
);

BasicNumberInput.displayName = 'BasicNumberInput';
